// --- Thresholds ---

export const IMPRESSIONS_DANGER_THRESHOLD = 5000;
export const IMPRESSIONS_WARNING_THRESHOLD = 2000;
export const PCT_IMPRESSIONS_DANGER_THRESHOLD = 50;
export const PCT_IMPRESSIONS_WARNING_THRESHOLD = 30;
export const PCT_OVERPRICED_DANGER_THRESHOLD = 15;
export const PCT_OVERPRICED_WARNING_THRESHOLD = 8;
export const PCT_OVERPRICED_GOOD_THRESHOLD = 5;
export const BEDBANK_LPC_DANGER_THRESHOLD = 80;
export const BEDBANK_LPC_WARNING_THRESHOLD = 50;
export const YOY_DECLINE_HIGH_THRESHOLD = 30;

// --- VNS Days colors ---
export const VNS_DAYS_GOOD = '#e8f5e9';
export const VNS_DAYS_WARNING = '#fff3e0';
export const VNS_DAYS_DANGER = '#ffebee';

// --- Formatters ---

export function formatNumber(value: number): string {
  return value.toLocaleString();
}

export function formatPercentage(value: number): string {
  return `${value.toFixed(1)}%`;
}

export function formatCurrency(value: number): string {
  return `$${value.toFixed(2)}`;
}

// --- Severity classifiers ---

export function getImpressionsSeverity(value: number): string {
  if (value > IMPRESSIONS_DANGER_THRESHOLD) {
    return 'metric-danger';
  }
  if (value > IMPRESSIONS_WARNING_THRESHOLD) {
    return 'metric-warning';
  }
  return '';
}

export function getPctImpressionsSeverity(value: number): string {
  if (value > PCT_IMPRESSIONS_DANGER_THRESHOLD) {
    return 'metric-danger';
  }
  if (value > PCT_IMPRESSIONS_WARNING_THRESHOLD) {
    return 'metric-warning';
  }
  return '';
}

export function getPctOverpricedSeverity(value: number): string {
  if (value > PCT_OVERPRICED_DANGER_THRESHOLD) {
    return 'metric-danger';
  }
  if (value > PCT_OVERPRICED_WARNING_THRESHOLD) {
    return 'metric-warning';
  }
  if (value < PCT_OVERPRICED_GOOD_THRESHOLD) {
    return 'metric-good';
  }
  return '';
}

export function getBedbankLpcSeverity(value: number | null | undefined): string {
  if (value == null) {
    return '';
  }
  if (value >= BEDBANK_LPC_DANGER_THRESHOLD) {
    return 'metric-danger';
  }
  if (value >= BEDBANK_LPC_WARNING_THRESHOLD) {
    return 'metric-warning';
  }
  return 'metric-good';
}

// --- VNS Days helpers ---

export function getVnsDaysBgColor(days: number): string {
  if (days <= 10) {
    return VNS_DAYS_GOOD;
  }
  if (days <= 20) {
    return VNS_DAYS_WARNING;
  }
  return VNS_DAYS_DANGER;
}
